import { Module } from 'vuex';

export class AuthState {
  public token: string | null = null;
  public authenticated: boolean = false;
}

const authModule: Module<AuthState, any> = {
  namespaced: true,
  state: () => {
    const state = new AuthState();
    state.token = getAuthToken();
    state.authenticated = !!state.token;
    return state;
  },

  getters: {
    authenticated: (state: AuthState) => state.authenticated && !isTokenExpired(state.token),
    token: (state: AuthState) => isTokenExpired(state.token) ? null : state.token,
    expired: (state: AuthState) => isTokenExpired(state.token),
  },

  mutations: {
    refreshToken: (state: AuthState) => {
      const token = getAuthToken();
      state.token = token;
      state.authenticated = !!token;
    },
  },

  actions: {
    setAuthToken: ({ commit }, token: string) => {
      setAuthToken(token, getExpiresFromJWT(token));
      commit('refreshToken');
    },
    deleteAuthToken: ({ commit }) => {
      setAuthToken('');
      commit('refreshToken');
    },
  },
};

const isTokenExpired = (token: string | null) => {
  if (!token) {
    return false;
  }

  const expires = getExpiresFromJWT(token);
  return expires <= new Date(Date.now());
};

const getAuthToken = () =>
  (document.cookie.match(/_token=(.*?)(;|$)/) || [])[1] || null;

const getExpiresFromJWT = (jwt: string) => {
  try {
    const section = jwt.split('.')[1];
    const obj = JSON.parse(new Buffer(section, 'base64').toString('utf8'));
    return new Date(obj.exp * 1000);
  } catch (error) {
    // tslint:disable-next-line:no-console
    console.error(`Error getting expires from JWT: ${jwt}`);
    return new Date(Date.now() + 1 * 60 * 60 * 1000);
  }
};

const setAuthToken = (token: string, expDate?: Date) => {
  const date = expDate || new Date(0);
  document.cookie = `_token=${token};expires=${date.toUTCString()};path=/`;
};

export default authModule;
